export default __webpack_public_path__ + "img/c71ed7a661ea222b3bf235a1a28997a7.svg";